(function ($) {
    Eloca.behaviors.bemmelhorV2Config = function (context) {
        const $switch = $(".js-bemmelhor-v2-transcricao-switch", context);
        const $modal = $("#modalConfirmarTranscricaoBemMelhorV2", context);
        const $modalRamais = $("#modalBemMelhorV2RamalPipelines", context);
        const $form = $(".js-bemmelhor-v2-config-form", context);

        if ($switch.length && $modal.length) {
            let confirmadoPeloUsuario = $switch.is(":checked");
            let ignorarChange = false;

            const desativarSwitch = function () {
                ignorarChange = true;
                $switch.prop("checked", false);
                confirmadoPeloUsuario = false;
                ignorarChange = false;
            };

            const ativarSwitch = function () {
                ignorarChange = true;
                $switch.prop("checked", true);
                confirmadoPeloUsuario = true;
                ignorarChange = false;
            };

            $switch
                .off("change.bemmelhorV2Config")
                .on("change.bemmelhorV2Config", function () {
                    if (ignorarChange) {
                        return;
                    }

                    if (!$switch.is(":checked")) {
                        confirmadoPeloUsuario = false;
                        return;
                    }

                    if (confirmadoPeloUsuario) {
                        return;
                    }

                    desativarSwitch();
                    $modal.modal("show");
                });

            $modal
                .find(".js-bemmelhor-v2-transcricao-concordar")
                .off("click.bemmelhorV2Config")
                .on("click.bemmelhorV2Config", function () {
                    ativarSwitch();
                    $modal.modal("hide");
                });

            $modal
                .find(".js-bemmelhor-v2-transcricao-recusar")
                .off("click.bemmelhorV2Config")
                .on("click.bemmelhorV2Config", function () {
                    desativarSwitch();
                });

            $modal
                .off("hidden.bs.modal.bemmelhorV2Config")
                .on("hidden.bs.modal.bemmelhorV2Config", function () {
                    if (!$switch.is(":checked")) {
                        confirmadoPeloUsuario = false;
                    }
                });
        }

        if (!$modalRamais.length) {
            return;
        }

        const obterLabelPipelinePadrao = function () {
            const $pipelinePadrao = $form.find(".js-bemmelhor-v2-pipeline-padrao");
            const textoSelecionado = $.trim(
                $pipelinePadrao.find("option:selected").text() || ""
            );

            if (!textoSelecionado || textoSelecionado === "Selecione...") {
                return "Padrão da loja";
            }

            return "Padrão: " + textoSelecionado;
        };

        const montarHtmlPipeline = function (pipelineId, pipelineLabel) {
            if (pipelineId) {
                return $("<div>").text(pipelineLabel).html();
            }

            return (
                '<span class="text-muted js-bemmelhor-v2-pipeline-padrao-label">' +
                $("<div>").text(obterLabelPipelinePadrao()).html() +
                "</span>"
            );
        };

        const sincronizarSelectsDoModal = function () {
            $modalRamais.find(".js-bemmelhor-v2-ramal-pipeline-select").each(function () {
                const $select = $(this);
                const ramal = $select.attr("data-ramal");
                const valorAtual = $(
                    '.js-bemmelhor-v2-ramal-pipeline-input[data-ramal="' + ramal + '"]'
                ).val();

                $select.val(valorAtual || "");
            });
        };

        const atualizarTabelaPipelines = function () {
            $modalRamais.find(".js-bemmelhor-v2-ramal-pipeline-select").each(function () {
                const $select = $(this);
                const ramal = $select.attr("data-ramal");
                const valor = $select.val() || "";
                const label = valor
                    ? $.trim($select.find("option:selected").text())
                    : "";

                $(
                    '.js-bemmelhor-v2-ramal-pipeline-input[data-ramal="' + ramal + '"]'
                ).val(valor);

                $(
                    '.js-bemmelhor-v2-pipeline-label[data-ramal="' + ramal + '"]'
                )
                    .attr("data-pipeline-id", valor)
                    .html(montarHtmlPipeline(valor, label));
            });
        };

        $modalRamais
            .off("show.bs.modal.bemmelhorV2RamalPipelines")
            .on("show.bs.modal.bemmelhorV2RamalPipelines", function () {
                sincronizarSelectsDoModal();
            });

        $modalRamais
            .find(".js-bemmelhor-v2-aplicar-ramal-pipelines")
            .off("click.bemmelhorV2RamalPipelines")
            .on("click.bemmelhorV2RamalPipelines", function () {
                atualizarTabelaPipelines();
                $modalRamais.modal("hide");
            });

        $form
            .find(".js-bemmelhor-v2-pipeline-padrao")
            .off("change.bemmelhorV2PipelinePadrao")
            .on("change.bemmelhorV2PipelinePadrao", function () {
                $(".js-bemmelhor-v2-pipeline-label", context).each(function () {
                    const $celula = $(this);

                    if ($celula.attr("data-pipeline-id")) {
                        return;
                    }

                    $celula.html(montarHtmlPipeline("", ""));
                });
            });
    };
})(jQuery);
